import BaseBarsChartsStrategy from './BaseBarsChartsStrategy'
import {ChartType} from '../../../constants'

export default class VerticalBarsChartStrategy extends BaseBarsChartsStrategy {
    constructor() {
        super(ChartType.VERTICAL_BAR)
    }

}



// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfgenerator/doStrategy/VerticalBarsChartStrategy.js